import _ from "lodash";
import React, { useState, Fragment } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch, Route, Switch } from "react-router-dom";
import { Nav, NavLink, NavItem } from "reactstrap";
import IntlMessages from "util/intlMessages";

import Info from "./Info";
import ChannelsTable from "views/admin/Channels/Table";
import Users from "./Users";

const PartnerInfoData = (props) => {
  const { url, path } = useRouteMatch();
  const params = useParams();
  const [currentTab, setCurrentTab] = useState(0);

  const { partner } = props;
  const NavTabs = [
    {
      path: "/",
      title: <IntlMessages id="Partners.Info" />,
      component: <Info {...partner} />,
    },
    {
      path: "/messages",
      title: <IntlMessages id="Channels" />,
      component: <ChannelsTable {...partner} />,
    },
    {
      path: "/accounts",
      title: <IntlMessages id="Partners.Users" />,
      component: <Users />,
    },
  ];
  return (
    <>
      <Route path={path}>
        <div className="mb-1">
          <Nav tabs>
            {NavTabs.map((navTab, index) => {
              const link = url + _.toString(navTab.path);
              return (
                <Fragment key={index}>
                  <NavItem>
                    <span className={`nav-link ${currentTab === index ? "active" : ""}`}>
                      <Link to={link}>{navTab.title || <IntlMessages id={navTab.id} />}</Link>
                    </span>
                  </NavItem>
                </Fragment>
              );
            })}
          </Nav>
        </div>

        <Switch>
          {NavTabs.map((navTab, index) => {
            const link = path + _.toString(navTab.path);
            return (
              <Route
                key={index}
                exact
                path={link}
                render={() => {
                  setCurrentTab(index);
                  return <Fragment key={index}>{navTab.component}</Fragment>;
                }}
              />
            );
          })}
        </Switch>
      </Route>
    </>
  );
};

export default connect(null, {})(PartnerInfoData);
